<script>
  import Title from './Title.svelte'
  import Message from './Message.svelte'
  import ReadMore from '../../components/ReadMore.svelte'

  export let message
  export let title
  export let isQna = false
  export let color
  export let contentSize = 14
  export let titleSize = 14
  export let textDirection
  export let readMoreText
  export let readMoreTextColor
  export let readLessText
</script>

<section style={`color: ${color}; direction:${textDirection};`}>
  {#if !isQna}
    <Title fontSize={titleSize} {title} />
  {/if}
  <ReadMore
    text={message}
    component={Message}
    fontSize={contentSize}
    {readLessText}
    {readMoreText}
    {readMoreTextColor} />
</section>
